<template>
  <div>
    <Head title="Barazimet" />
    <h1 class="mb-8 text-3xl font-bold">Barazimet
      <Link class="btn-indigo mr-3" href="/barazimet/gjendja">
      <span>Gjendja aktuale</span>
      </Link>
    </h1>



    <div class="flex flex-wrap lg:flex-nowrap mb-6  items-center justify-between">

      <div  class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/2 ">

        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
          <label class="block text-gray-700">Biznesi shitës:</label>
          <select v-model="form.business_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="business in businesses" :value="business.id">{{ business.name }}</option>
          </select>
        </search-filter>

        <a :href="route('seller.barazimet.excel',this.form)" download class="pb-1"><icon name="excel"></icon></a>

      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label text-gray-700">Statusi:</label>
        <Multiselect
          v-model="form.status_ids"
          :options="filterStatuses.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />

      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e regjistrimit:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>


      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e ndryshimit të statusit:</label>
        <input v-model="form.start_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>
    </div>


    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-2">Lokacioni</th>
          <th class="pb-4 pt-6 px-2">Totali në EUR</th>
<!--          <th class="pb-4 pt-6 px-2">Numri i dërgesave</th>-->
          <th class="pb-4 pt-6 px-2">Statusi</th>
          <th class="pb-4 pt-6 px-2">Dokumenti</th>
          <th class="pb-4 pt-6 px-2">Shoferi</th>
          <th class="pb-4 pt-6 px-2">Krijuar më</th>
          <th class="pb-4 pt-6 px-2">Statusi edituar më</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="barazim in barazims.data" :key="barazim.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t px-2">
            <Link class="flex items-center  px-2 py-4" :href="`/barazimet/${barazim.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>

          <td class="border-t px-2">
            {{ barazim.id }}
            <icon v-if="barazim.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
          </td>
          <td class="border-t px-2">
            {{ barazim.business }}
          </td>
          <td class="border-t px-2">
            {{ barazim.location }}
          </td>
          <td class="border-t px-2">
            {{ barazim.total_neto_amount }}
          </td>
<!--          <td class="border-t px-2">-->
<!--            {{ barazim.orders_count }}-->
<!--          </td>-->
          <td class="border-t px-2">
            <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getStatusColor(barazim.status_id)">{{ barazim.status }}</span>
          </td>
          <td class="border-t px-2">
            <a v-if="barazim.document_path"  class="px-4 py-1 items-center text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('files.download', {path: barazim.document_path})" download>Shkarko</a>
          </td>
          <td class="border-t px-2">
            {{ barazim.collecting_driver }}
          </td>
          <td class="border-t px-2">
            {{ barazim.hr_created_at }}
          </td>
          <td class="border-t px-2">
            {{ barazim.updated_status_at }}
          </td>
          <td class="w-px border-t">

            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <icon name="three-dots" class="block w-12 h-6 fill-gray-400"/>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.barazim.order.pdf',{barazim: barazim.id})"  target="_blank">Printo PDF</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.barazimet.excel.single',{barazim: barazim.id})"  target="_blank">Eksporto Excel</a>
                </div>
              </template>
            </dropdown>
          </td>
        </tr>
        <tr v-if="barazims.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje barazim.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap">
      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12"
      >
        <option v-if="barazims.meta.total > 15" value="15">15 / {{barazims.meta.total}}</option>
        <option v-if="barazims.meta.total > 30"  value="30">30 / {{barazims.meta.total}}</option>
        <option v-if="barazims.meta.total > 50"  value="50">50 / {{barazims.meta.total}}</option>
        <option v-if="barazims.meta.total > 100"  value="100">100 / {{barazims.meta.total}}</option>
        <option :value="barazims.meta.total">{{barazims.meta.total}} / {{barazims.meta.total}}</option>

      </select-input>

      <pagination class="mt-6" :links="barazims.meta.links"/>

    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import Dropdown from '@/Shared/Dropdown'
import {computed} from 'vue'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown,
    FileInput,
    Modal,
    LoadingButton,
    SelectInput,
    Multiselect
  },
  layout: Layout,
  props: {
    filters: Object,
    businesses: Object,
    barazims: Object,
    statuses: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        business_id: this.filters.business_id,
        status_ids: this.filters.status_ids,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        start_date_status_updated: this.filters.start_date_status_updated,
        end_date_status_updated: this.filters.end_date_status_updated,

        per_page: this.barazims.meta.total < 15 ? this.barazims.meta.total : this.barazims.meta.per_page,
      },
      filterStatuses: {
        options: this.statuses.map(function(status){
          return {value: status.id, label: status.name}
        }),
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/barazimet', pickBy(this.form), {preserveState: true})
      }, 150),
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },

    getStatusColor(statusId){
      let statusColor = 'bg-indigo-500'
      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 2)
        statusColor = 'bg-orange-500'

      if(statusId === 3)
        statusColor = 'bg-indigo-900'

      if(statusId === 4)
        statusColor = 'bg-green-500'

      if(statusId === 5)
        statusColor = 'bg-red-500'

      if(statusId === 6)
        statusColor = 'bg-yellow-700'

      return statusColor
    }
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
